import type { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import type { TypographyProps } from '@elfsight/widget-ui';
import { Typography } from '@elfsight/widget-ui';
import { createReadableClass } from '@elfsight/widget-utils';
import { ellipsis } from '../../../helpers';
import type { ExtendedAudioItem } from '../../sources';
import { Ticker } from './Ticker';

interface AuthorProps extends PropsWithChildren {
  textStyle: TypographyProps['textStyle'];
  disableTicker: boolean;
  track?: ExtendedAudioItem;
}

export function Author({ textStyle, disableTicker, children }: AuthorProps) {
  return (
    <Ticker
      className={createReadableClass({
        component: 'track-info',
        element: 'author-ticker'
      })}
      disabled={disableTicker}
    >
      <StyledAuthor textStyle={textStyle} _disableTicker={disableTicker}>
        {children}
      </StyledAuthor>
    </Ticker>
  );
}

export const StyledAuthor = styled(Typography).attrs<{
  _disableTicker?: boolean;
}>({
  className: createReadableClass({
    component: 'track-info',
    element: 'author'
  })
})`
  opacity: 0.7;
  white-space: nowrap;

  ${({ _disableTicker }) =>
    _disableTicker &&
    css`
      max-width: 100%;
      ${ellipsis};
    `};
`;
